import { useGetAvailableRoles } from "@vega-api/generated/coinvest-deal-permission/coinvest-deal-permission";
import { type AvailableRole } from "@vega-api/generated/types/availableRole";
import { type OptionType } from "@vega-core/models/options";

export const DEFAULT_DEAL_ROLE_NAME = "Investor Manager";

export const useDealRoles = () => {
  const {
    data: rolesResponse,
    isPending,
    isError,
    isFetching,
    refetch,
  } = useGetAvailableRoles({
    query: { select: (data) => data.data },
  });

  const roles = rolesResponse?.roles ?? [];

  const roleOptions: OptionType[] = roles.map((role) => ({
    label: role.name,
    value: role.name,
  }));

  const roleById = new Map(roles.map((role) => [role.id, role] as const));
  const roleByName = new Map(roles.map((role) => [role.name, role] as const));

  const defaultRole = roleByName.get(DEFAULT_DEAL_ROLE_NAME) ?? roles.at(0);
  const defaultRoleId = defaultRole?.id ?? "";

  const getRoleById = (roleId: string): AvailableRole | undefined =>
    roleById.get(roleId);

  const getRoleByName = (roleName: string): AvailableRole | undefined =>
    roleByName.get(roleName);

  return {
    roles,
    roleOptions,
    defaultRoleId,
    getRoleById,
    getRoleByName,
    isPending,
    isError,
    isFetching,
    refetch,
  };
};
